"use strict";

exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];


// WEBPACK FOOTER //
// ./~/dom-helpers/ownerDocument.js